<template>
	<BaseCmsPage :fetchSlugSegments="2" v-slot="{page}">
		<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
		<div v-if="page?.content" v-html="page.content" />
		<ClientOnly>
			<BaseNewsletterConfirmSubscribe v-slot="{status}">
				<div class="newsletter-success-cnt">
                    <BaseCmsLabel tag="div" :code="status?.label_name" />
                </div>
			</BaseNewsletterConfirmSubscribe>
		</ClientOnly>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
.newsletter-success-cnt{padding: 60px 15px; text-align: center;}
</style>
